import React from "react";
import "style/ModalDropdown.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

import en from "../config/i18n/english/english";
import de from "../config/i18n/german/german";

interface Props {
  showDropdown: boolean;
  showDropdownLanguage?: boolean;

  homepage?: boolean;
  imprint?: boolean;
  contact?: boolean;
}

interface State {
  language: any;
  languageActiv: any;
}

class ModalDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      language: en,
      languageActiv: "en",
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem("lang") === null) {
      const browserLanguage = navigator.language.split("-")[0];
      this.setState({
        language: browserLanguage === "de" ? de : en,
        languageActiv: browserLanguage === "de" ? "de" : "en",
      });
      sessionStorage.setItem("lang", browserLanguage);
    } else {
      this.setState({
        language: sessionStorage.getItem("lang") === "de" ? de : en,
        languageActiv: sessionStorage.getItem("lang"),
      });
    }
  }

  handleLanguage(language: string) {
    if (language !== sessionStorage.getItem("lang")) {
      sessionStorage.setItem(
        "lang",
        sessionStorage.getItem("lang") === "de" ? "en" : "de"
      );
      window.location.reload();
    }
  }

  render() {
    const { language } = this.state;
    return (
      <>
        {this.props.showDropdown ? (
          <div className="background">
            <div className="modalWrapper">
              <div className="modalContent ps-5">
                <hr />
                <Link to="/" className="modal-links">
                  <p
                    style={
                      this.props.homepage ? { color: "#7FF1AB" } : { color: "" }
                    }
                  >
                    {language.dropdown.overview}
                  </p>
                </Link>
                <hr />
                <Link to="/contact" className="modal-links">
                  <p
                    style={
                      this.props.contact ? { color: "#7FF1AB" } : { color: "" }
                    }
                  >
                    {language.dropdown.contact}
                  </p>
                </Link>
                <hr />
                <Link to="/imprint" className="modal-links">
                  <p
                    style={
                      this.props.imprint ? { color: "#7FF1AB" } : { color: "" }
                    }
                  >
                    {language.dropdown.imprint}
                  </p>
                </Link>
                <hr />
              </div>
            </div>
          </div>
        ) : null}

        {this.props.showDropdownLanguage ? (
          <div className="background">
            <div className="modalWrapper">
              <div className="modalContent ps-5">
                <hr />

                <button
                  className="btn-language"
                  onClick={() => {
                    this.handleLanguage("en");
                  }}
                >
                  <p
                    style={
                      this.state.languageActiv === "en"
                        ? { color: "#7FF1AB" }
                        : { color: "" }
                    }
                  >
                    {this.state.languageActiv === "en" ? "English" : "Englisch"}
                  </p>
                </button>
                <hr />
                <button
                  className="btn-language"
                  onClick={() => {
                    this.handleLanguage("de");
                  }}
                >
                  <p
                    style={
                      this.state.languageActiv === "de"
                        ? { color: "#7FF1AB" }
                        : { color: "" }
                    }
                  >
                    {this.state.languageActiv === "de" ? "Deutsch" : "German"}
                  </p>
                </button>
                <hr />
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default ModalDropdown;
